import React from 'react';
import classNames from 'classnames';

import thick from 'assets/icons/white-thick.svg';

// Yes, we have two statuses for the same thing. That's the requirement.
const PAID = 'Paid';
const COMPLETED = 'Completed';

import './styles.css';

const DepositSummaryStatus = ({status}) => {
  const completed = status === COMPLETED || status === PAID;

  return (
    <div
      className={classNames('DepositSummaryStatus colab-centered', {
        completed
      })}>
      <div className="colab-bold">{status}</div>
      {completed && <img src={thick} alt="thick icon" />}
    </div>
  );
};

export default DepositSummaryStatus;
